module.exports = __webpack_public_path__ + "static/media/they_are_going_home.60adbf5b.gif";